import React, { useState } from 'react';
import { Box } from '@mui/material';
import NeonCard from '../ui/NeonCard';
import usePainMapGender from '../../hooks/usePainMapGender';
import usePainMapping from '../../hooks/usePainMapping';
import PainBodyMap from '../PainBodyMap';

export default function PainMapPanel({
  emiratesId,
  patientName,
  painCaptureEnabled = false,
  painCaptureSessionKey = 0,
  onPainLocationConfirmed,
  onPainCapturePrompt,
  onPainCaptureExpired,
  sx = {},
}) {
  const [gender, setGender] = usePainMapGender(emiratesId, patientName);
  const [view, setView] = useState('front');
  const {
    pendingSelection,
    primaryLocation,
    secondaryLocation,
    interactionLocked,
    setPendingLocation,
    clearLocation,
    confirmLocation,
    resetMapForViewChange,
    notifyBlockedInteraction,
    resetFatigueTimer,
    clearFatigueTimer,
  } = usePainMapping({
    gender,
    view,
    captureEnabled: painCaptureEnabled,
    captureSessionKey: painCaptureSessionKey,
    onLocationConfirmed: onPainLocationConfirmed,
    onCapturePrompt: onPainCapturePrompt,
    onCaptureExpired: onPainCaptureExpired,
  });

  const handleViewChange = (nextView) => {
    if (!nextView || nextView === view) return;
    setView(nextView);
    resetMapForViewChange();
  };

  return (
    <NeonCard
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        overflow: 'hidden',
        maxWidth: '100%',
        p: 0,
        gap: 0,
        position: 'relative',
        ...sx,
      }}
    >
      <PainBodyMap
        gender={gender}
        view={view}
        captureMode={painCaptureEnabled}
        pendingSelection={pendingSelection}
        confirmedSelections={[primaryLocation, secondaryLocation].filter(Boolean)}
        interactionLocked={interactionLocked}
        onGenderChange={setGender}
        onViewChange={handleViewChange}
        onPendingSelection={setPendingLocation}
        onBlockedInteraction={notifyBlockedInteraction}
        onConfirmLocation={confirmLocation}
        onClearLocation={clearLocation}
        onDragStart={resetFatigueTimer}
        onDragEnd={clearFatigueTimer}
      />
    </NeonCard>
  );
}

